import Suspense from './Suspense';

export default Suspense;
